<template>
  <canvas
    :width  = "layerWidth"
    :height = "layerHeight"
  >
  </canvas>
</template>

<script>
export default {
  name: 'CanvasLayer',
  data () {
    return {
      context: ''
    }
  },
  props    : [ 'layerId', 'width', 'height' ],
  computed : {
    layerWidth  () { return this.width || 800 },
    layerHeight () { return this.height || 600 }
  },
  mounted () {
    this.context = this.$el.getContext('2d')
  },
  methods: {
    draw ({
      type,
      beginX,
      beginY,
      closeX,
      closeY,
      contextProperty
    }) {
      this.changeStyle(contextProperty)

      if (type === 'spot') {
        this.context.globalAlpha = this.context.globalAlpha * contextProperty.lineWidth / 2
        this.drawSpot(closeX, closeY)
      } else if (type === 'line') {
        this.drawLine({
          x1 : beginX,
          x2 : closeX,
          y1 : beginY,
          y2 : closeY
        })
      }
    },
    changeStyle ({
      lineColor,
      lineWidth,
      lineCap,
      alpha,
      blur,
      shodowColor,
      composite
    }) {
      this.context.strokeStyle = lineColor || 'rgba(0,0,0,1)'
      this.context.lineWidth   = lineWidth || 3
      this.context.lineCap     = lineCap || 'round'
      this.context.globalAlpha = typeof alpha === 'number' || alpha === 1 ? alpha : 1 / (lineWidth / 2)
      this.context.shadowBlur  = blur || 0
      this.context.shadowColor = shodowColor || lineColor || 'rgba(0,0,0,1)'
      this.context.globalCompositeOperation = composite || 'source-over'
    },
    clear () {
      this.context.clearRect(0, 0, this.layerWidth, this.layerHeight)
    },
    // Draw a line between two points.
    drawLine ({
      x1,
      x2,
      y1,
      y2
    }) {
      const dx = Math.abs(x2 - x1)
      const dy = Math.abs(y2 - y1)
      const sx = (x1 < x2) ? 1 : -1
      const sy = (y1 < y2) ? 1 : -1
      let err  = dx - dy

      while (!((x1 === x2) && (y1 === y2))) {
        const e2 = err << 1
        if (e2 > -dy) {
          err -= dy
          x1  += sx
        }
        if (e2 < dx) {
          err += dx
          y1  += sy
        }
        this.drawSpot(x1, y1)
      }
    },
    drawSpot (x, y) {
      this.context.beginPath()
      this.context.moveTo(x, y)
      this.context.lineTo(x, y)
      this.context.stroke()
      this.context.closePath()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
canvas {
  position : absolute;
  top      : 0px;
  left     : 0px;
  z-index  : 100;
}
</style>



// WEBPACK FOOTER //
// src/components/canvas/content/CanvasLayer.vue